import { render, staticRenderFns } from "./assessment-question.vue?vue&type=template&id=62f5a4e6&scoped=true&"
import script from "./assessment-question.vue?vue&type=script&lang=js&"
export * from "./assessment-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5a4e6",
  null
  
)

export default component.exports